import { pxToRem } from "utility/getFontValue";

export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        size: "large",
      },
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 60,
          boxSizing: "border-box",
          ":disabled": {
            background: "#EAEAEA",
            color: "#BDBDBD",
            border: "none",
          },
        },
        sizeLarge: {
          fontSize: pxToRem(17),
          lineHeight: pxToRem(26)
        },
        sizeMedium:{
          fontSize: pxToRem(16),
        },
        sizeSmall: {
          fontSize: pxToRem(15),
        }
      },
      variants: [
        {
          props: { variant: "contained" },
          style:{
            boxShadow: "none"
          }
        },
        {
          props: { variant: "contained", color: "warning" },
          style: {
            background: theme.palette.warning.main,
            color: "#FFF9EA",
            ":hover": {
              background: theme.palette.warning.main,
              color: "#F6F6F6",
            },
          },
        },
        {
          props: { variant: "contained", color: "error" },
          style: {
            background: "#FFEDEC",
            color: theme.palette.error.main,
            ":hover": {
              background: theme.palette.error.main,
              color: "#FFEDEC",
            },
          },
        },
        {
          props: { variant: "standard", color: "primary" },
          style: {
            background: "#FFFFFF",
            color: "#707070",
            border: "1px solid #707070",
            padding: "7px 21px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
            ":hover": {
              background: "#0000000A",
              color: "#707070",
              boxShadow: "0px 1px 8px 0px #00000026",
            },
            ":disabled": {
              padding: "8px 22px",
            },
          },
        },
        {
          props: { variant: "rest", color: "primary" },
          style: {
            background: "#FFFFFF",
            boxShadow: "0px 8px 108px rgba(0, 0, 0, 0.12)",
            color: "#1F7B44",
            ":hover": {
              background: "#F2F9EF",
              boxShadow: "0px 4px 108px rgba(0, 0, 0, 0.2)"
            },
          },
        },
      ],
    },
  };
}